import React from "react";
import { MessageCircle, Phone, MessageSquareText } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { links } from "../../lib/api";

export const ContactButtons = ({ id, className = "" }) => {
  const { content, openChat, t } = useSite();
  const l = links(content);
  return (
    <div className={`flex flex-wrap gap-3 ${className}`} data-testid={`${id}-contact-buttons`}>
      <button onClick={() => openChat()} className="sw-btn-primary" data-testid={`${id}-live-chat`}><MessageCircle size={16} />{t("Live Chat")}</button>
      <span className="inline-flex overflow-hidden rounded-full border border-[#cfe7e2] bg-white text-[#0f2e2a]">
        <a href={l.tel} className="inline-flex items-center gap-1.5 px-4 py-2.5 text-[14.5px] font-semibold transition-colors hover:bg-[#eef8f6]" data-testid={`${id}-call`}><Phone size={15} className="text-[#0e8c7f]" />{t("Call")}</a>
        <span className="w-px bg-[#cfe7e2]" />
        <a href={l.sms} className="inline-flex items-center gap-1.5 px-4 py-2.5 text-[14.5px] font-semibold transition-colors hover:bg-[#eef8f6]" data-testid={`${id}-text`}><MessageSquareText size={15} className="text-[#0e8c7f]" />{t("Text")}</a>
      </span>
      <a href={l.wa} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 rounded-full bg-[#25d366] px-4 py-2.5 text-[14.5px] font-semibold text-white transition-colors hover:bg-[#1ebe5b]" data-testid={`${id}-whatsapp`}><MessageCircle size={15} />WhatsApp</a>
    </div>
  );
};
